// Single source for everything on the site that comes from Resume_Steven_Camacho.pdf.
// When the resume changes, update this file so the site stays in sync with it.

export const profile = {
    name: 'Steven Camacho',
    // Profile picture: put the image in public/ and set its path here, e.g. '/profile.jpg'.
    // If set to null, the home page shows an initials placeholder in the same spot.
    photo: '/headshot.jpg',
    role: 'M.S. Computer Science student at the University of Central Florida',
    email: 'stevenacamachoperez@gmail.com',
    phone: '954-798-8713',
    phoneHref: 'tel:+19547988713',
    linkedin: 'https://www.linkedin.com/in/steven-camacho-96a818268/',
    linkedinLabel: 'linkedin.com/in/steven-camacho',
    github: 'https://github.com/stevenc15',
    githubLabel: 'github.com/stevenc15',
    resumePdf: '/resume.pdf',
};

export const education = [
    {
        school: 'University of Central Florida',
        location: 'Orlando, Florida',
        degree: 'Master of Science',
        field: 'Computer Science',
        period: 'August 2025 – May 2027 (Expected)',
        gpa: '3.9',
    },
    {
        school: 'University of Central Florida',
        location: 'Orlando, Florida',
        degree: 'Bachelor of Science',
        field: 'Computer Science',
        period: 'August 2020 – September 2024',
        gpa: '3.7',
    },
];

export const experience = [
    {
        company: 'Alvarez & Marsal',
        location: 'Dallas, Texas',
        title: 'Digital Tax Services Intern (Software Engineering)',
        period: 'June 2026 – August 2026',
        tags: ['.NET', 'Model Context Protocol', 'Code generation'],
        bullets: [
            'Enabled scalable, chatbot-driven backend tool execution on A&M’s Global Engage platform, architected to support 290+ GET endpoints, by building a .NET Model Context Protocol (MCP) server as a proof-of-concept for broader rollout.',
            'Accelerated MCP tool expansion across a 290+ endpoint backend, cutting endpoint onboarding from manual and individual tool creation to a single scripted generation step, by engineering a reflection-based code-generation pipeline.',
            'Eliminated a token passthrough anti-pattern, where Engage’s auth token was forwarded through an unauthorized LLM service, by re-architecting the chatbot to call MCP tools directly, coordinated through a bounded 5-step tool-call/final-answer execution contract with structured logging.',
        ],
    },
    {
        company: 'UCF Evolutionary Computation Group',
        location: 'Orlando, Florida',
        title: 'Graduate Research Assistant',
        period: 'September 2025 – December 2025',
        tags: ['Python', 'Genetic algorithms', 'Discrete-event simulation', 'Job shop scheduling'],
        bullets: [
            'Automated evaluation of makespan-based fitness across thousands of candidate schedules per run for the job shop scheduling problem by designing and implementing a genetic algorithm integrated with a custom discrete-event scheduler adapted from an internal FabSim simulation codebase.',
            'Preserved job-specific scheduling invariants while keeping the GA pipeline fully decoupled for independent tuning of fitness, operators, and configuration, by maintaining problem-aware selection/mutation operators.',
            'Enabled statistically rigorous, reproducible validation of GA behavior, with per-generation observability, by refactoring exploratory research notebooks into a modular, testable Python package.',
        ],
    },
];
